import {ChangeDetectionStrategy, Component, effect, inject, input} from '@angular/core';
import {ItcAuthPage, TAuthModal} from '@features/itc-auth-page/itc-auth-page';
import {Nav} from '@entities/navigation/nav';
import {UserStore} from '@library/entities/user/user.store';


@Component({
  selector: 'app-login',
  template: '<app-itc-auth-page [type]="type()" />',
  imports: [
    ItcAuthPage
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent {
  type = input<TAuthModal>('login');
  private user = inject(UserStore);
  private nav = inject(Nav);

  constructor() {
    effect(() => {
      if (this.user.isLogged()) {
        this.nav.toLastPage();
      }
    });
  }
}
